<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2 langkey="phBasketPay_OptionDialog_Title"></h2>
    <div class="divider"></div>
    <span langkey="phBasketPay_OptionDialog_Description"></span>
    <div class="paychoise">
      <button class="paywaiter" (click)="waiterCall()">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-waiterpay"></div>
        <div class="paytext">
          <span langkey="phBasketPay_OptionDialog_PayWaiterBtn"></span>
        </div>
      </button>
      <button class="payonline" (click)="navigateToinHausePayment()">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-payonline"></div>
        <div class="paytext">
          <span langkey="phBasketPay_OptionDialog_PayOnlineBtn"></span>
        </div>
      </button>
    </div>
  </div>
</div>